import { isMobile } from "@/lobby_common/utils/utils.js";
import hideGmae from "@/lobby_common/mixins/hideGmae.js";
import GameMaintai from "@/components/game/game-maintai";
import Collection from "@/components/collection/index.vue";
import { gameImg } from "@/lobby_common/utils/img.js";
import { debounce, formattedValue } from "@/lobby_common/utils/index.js";
import { payGameFun } from "@/lobby_common/utils/payGameFun.js";
import gameItem from "@/components/game/game-item";
import { divideAccuracy } from "@/lobby_common/utils/utils.js";
export default {
  mixins: [hideGmae],
  name: "game-hot",
  components: { Collection, GameMaintai, gameItem },
  props: {
    // 是否记录到路由历史, 默认不记录
    isHistory: {
      type: Boolean,
      default: false,
    },
    // 是否游戏搜索页
    isSearch: {
      type: Boolean,
      default: false,
    },
    // 当前游戏分类ID
    gameCategoryId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      formattedValue,
      gameImg,
      pcList: [],
      currGameId: null,
      page_num: 6,
      cur_left: 0,
      max_left: 0,
      timer: null,
      intervalId: null,
      updateInterval: 5000,
    };
  },
  computed: {
    list() {
      // return this.pcList;
      return this.pcList.map((item) => {
        return {
          ...item,
          currentValue: this.formattedValue(item.currentValue),
        };
      });
    },
    lang() {
      return this.$store.getters.getLang;
    },
    getIsMobile() {
      return this.$store.getters.getIsMobile;
    },
    cur_gid() {
      return this.$route.params.gid
        ? Number(this.$route.params.gid)
        : undefined;
    },
    coin_accuracy() {
      return this.$store.getters.getPacketConfig?.appConfig?.accuracy
        ? this.$store.getters.getPacketConfig?.appConfig?.accuracy
        : 2;
    },
    accuracy() {
      return this.$store.getters.getCurCoin?.accuracy || this.coin_accuracy;
    },
    packetConfig() {
      return this.$store.getters.getPacketConfig?.packetInfo?.baseInfo || {};
    },
    gameShow() {
      return this.packetConfig.gameNameShowPosition !== 4;
    },
    jp_show() {
      return this.packetConfig.gameIconShowJp === "ROW_STATUS_ENABLE";
    },
  },
  created() {
    const that = this;
    that.resizeHandler = debounce(() => {
      that.commonSySize();
    }, 300);
    window.addEventListener("resize", this.resizeHandler);
  },
  mounted() {
    // this.getGamelistFun();
    // const that = this;
    // // HomeSearch页点击收藏游戏  请求推荐游戏接口
    // that.$Bus.$on("getHotAfterCollection", function () {
    //   // that.getGamelistFun();
    // });
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    window.removeEventListener("resize", this.resizeHandler);
  },
  methods: {
    judgeMode(opt) {
      if (opt.canTestPlay === "STATUS_BOOL_FALSE") {
        this.$store.commit("setRecordGame", opt);

        payGameFun(opt);
      } else {
        // 游戏详情页面
        this.$isPopShow({
          show: true,
          views: "hgame",
          data: {
            ...opt,
          },
        });
      }
      // if (opt.canTestPlay === 'STATUS_BOOL_TRUE') {
      //   // 开启试玩模式
      //   this.currGameId = opt.gameGroupSid;
      //   return;
      // }
      // this.h5PayGame(opt);
    },
    h5PayGame(opt) {
      this.currGameId = null;
      this.$store.commit("setRecordGame", opt);
      this.$PayGame(opt.gameGroupSid, opt);
    },
    h5PayGameTry(opt) {
      // 试玩
      this.currGameId = null;
      this.$store.commit("setRecordGame", opt);
      this.$PayGame(opt.gameGroupSid, {
        ...opt,
        canTestPlay: 1,
      });
    },
    // PC弹出真玩、试玩收藏
    pcPayGame(opt) {
      if (this.maintaiGame[opt.gameGroupSid]) {
        return false;
      }
      if (this.cur_gid === opt.gameGroupSid) {
        return false;
      }
      this.currGameId = opt.gameGroupSid;
      return;
    },
    pcLeaveGame() {
      this.currGameId = null;
      return;
    },
    payGame(opt, canTestPlay, isRoom = false) {
      this.$store.commit("setRecordGame", opt);
      const replace = !this.isHistory;
      payGameFun(opt, canTestPlay, replace, isRoom);
    },
    btnCilck(opt) {
      this.$router.push(opt || "/");
    },
    async getGamelistFun() {
      // const web_type = this.getIsMobile ? "h5" : "pc";
      // const { code, data } = await getRecommendGameList({
      //   page: 1,
      //   page_size: 21,
      //   res_type: web_type,
      //   game_category_id: this.isSearch ? this.gameCategoryId : undefined,
      //   channel_id:
      //     this.$store.getters.getPacketConfig?.packet_config?.channel_id || 0,
      //   template_type: web_type,
      //   // tag_keys: ["hot"],
      //   // tag_keys: [],
      // });
      // if (code === 0) {
      // const games = data?.gameList || [];
      // games.forEach((item) => {
      //   if (item.jpInfo && item.jpInfo.jpValue > 0) {
      //     item.jpInfo.jpValue = divideAccuracy(
      //       item.jpInfo.jpValue,
      //       this.accuracy
      //     );
      //     item.jpInfo.updateTime = Number(item.jpInfo.updateTime);
      //   } else {
      //     item.jpInfo = {
      //       jpValue: 0,
      //       updateTime: 0,
      //     };
      //   }
      //   item.finalValue = item.jpInfo.jpValue;
      //   item.initiaValue = item.finalValue * 0.8;
      //   item.currentValue = this.offsetTimeValue(item);
      // });
      // this.pcList = games;
      // // this.pcList = data?.gameList || [];
      // if (this.jp_show && this.gameShow) {
      //   this.startIncrement();
      // }
      //   this.page_num = this.getIsMobile ? 3 : 6;
      //   if (this.pcList.length % this.page_num > 0) {
      //     // 不能整除
      //     this.max_left = Math.floor(this.pcList.length / this.page_num) * 100;
      //   } else {
      //     // 能整除
      //     this.max_left =
      //       (Math.floor(this.pcList.length / this.page_num) - 1) * 100;
      //   }
      //   // console.log(this.max_left)
      // }
    },
    getGameIcon(keys) {
      const key = keys || null;
      if (key) return require(`@/assets/new/${key}.png`);
    },
    commonSySize() {
      // location.reload()
      this.changInit();
    },
    changInit() {
      this.page_num = this.getIsMobile ? 3 : 6;
      if (this.pcList.length % this.page_num > 0) {
        // 不能整除
        this.max_left = Math.floor(this.pcList.length / this.page_num) * 100;
      } else {
        // 能整除
        this.max_left =
          (Math.floor(this.pcList.length / this.page_num) - 1) * 100;
      }
      this.cur_left = 0;
      const dom = document.querySelector(`.p-hot-box-slide`);
      if (dom) {
        dom.style.left = 0;
      }
    },
    changePosition(dir = "left") {
      const that = this;
      const dom = document.querySelector(`.p-hot-box-slide`);
      if (dom) {
        const target =
          dir === "left" ? that.cur_left - 100 : that.cur_left + 100;
        // if(that.cur_left === 0) dom.style.left = 0
        // else dom.style.left = `-${that.cur_left}00%`
        animate(target);
        function animate(target) {
          if (that.timer) {
            return false;
          }
          // let timer = that.timer;
          that.timer = setInterval(function () {
            const speed = dir === "left" ? -5 : 5; // 判断是向左走（负）还是向右走（正）
            // console.log(dir, that.cur_left, target)
            if (that.cur_left === target) {
              clearInterval(that.timer);
              that.timer = null;
            } else {
              that.cur_left = that.cur_left + speed;
              if (that.cur_left === 0) dom.style.left = 0;
              else dom.style.left = `-${that.cur_left}%`;
            }
          }, 10);
        }
      }
    },
    startIncrement() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        this.pcList = this.pcList.map((item) => {
          // const minIncrement = item.finalValue * 0.01;
          const maxIncrement = item.finalValue * 0.0005;

          if (item.currentValue < item.finalValue * 0.95) {
            // const randomIncrement = Math.random() * (maxIncrement - minIncrement) + minIncrement;

            item.currentValue += maxIncrement;

            if (item.currentValue > item.finalValue * 0.95) {
              item.currentValue = item.finalValue;
            }
          } else {
            item.currentValue = item.initiaValue;
          }
          return item;
        });
      }, this.updateInterval);
    },
    // 计算差值
    offsetTimeValue(item) {
      const jpInfo = item.jpInfo;
      if (!jpInfo.jpValue || jpInfo.jpValue < 1 || jpInfo.updateTime < 1) {
        return jpInfo.jpValue;
      }
      // 计算时间差值 (当前时间-数据更新时间) / 1000 * 每秒更新值
      const offset =
        ((Date.now() - jpInfo.updateTime) / 5000) * (jpInfo.jpValue * 0.0005);
      let currentValue = jpInfo.jpValue * 0.8 + offset;

      if (currentValue > jpInfo.jpValue * 0.95) {
        currentValue = jpInfo.jpValue * 0.8;
      }

      return currentValue;
    },
  },
};
